import React from 'react';
import { TrendingUpIcon, TrendingDownIcon, ArrowRightIcon, ActivityIcon } from 'lucide-react';
import { useLanguage } from './LanguageProvider';
const initialMarketItems = [{
  id: 1,
  marketplace: 'Mercado Livre',
  device: 'iPhone 13 Pro',
  grade: 'A Grade',
  price: 599,
  change: '+1.2%',
  isPositive: true,
  volume: '425 units'
}, {
  id: 2,
  marketplace: 'Americanas',
  device: 'Samsung S22',
  grade: 'B Grade',
  price: 449,
  change: '-0.8%',
  isPositive: false,
  volume: '156 units'
}, {
  id: 3,
  marketplace: 'OLX Brasil',
  device: 'iPhone 12',
  grade: 'A Grade',
  price: 399,
  change: '+2.1%',
  isPositive: true,
  volume: '283 units'
}, {
  id: 4,
  marketplace: 'Magazine Luiza',
  device: 'iPhone 13 Pro Max',
  grade: 'A Grade',
  price: 849,
  change: '+1.6%',
  isPositive: true,
  volume: '198 units'
}, {
  id: 5,
  marketplace: 'Amazon',
  device: 'iPhone 14 Pro',
  grade: 'A Grade',
  price: 899,
  change: '+2.4%',
  isPositive: true,
  volume: '567 units'
}, {
  id: 6,
  marketplace: 'eBay',
  device: 'Samsung S23 Ultra',
  grade: 'A Grade',
  price: 799,
  change: '+1.8%',
  isPositive: true,
  volume: '342 units'
}, {
  id: 7,
  marketplace: 'Facebook',
  device: 'iPhone 13',
  grade: 'B Grade',
  price: 499,
  change: '-1.2%',
  isPositive: false,
  volume: '234 units'
}];
const MarketplaceTag = ({
  marketplace
}) => {
  const styles = {
    'mercado livre': 'bg-[#FFE600] text-black',
    americanas: 'bg-[#E31837] text-white',
    'olx brasil': 'bg-[#6E0AD6] text-white',
    'magazine luiza': 'bg-[#0086FF] text-white',
    amazon: 'bg-[#FF9900] text-black',
    ebay: 'bg-[#0063D1] text-white',
    facebook: 'bg-[#1877F2] text-white'
  };
  return <span className={`inline-flex items-center px-2 py-1 rounded text-xs font-medium ${styles[marketplace.toLowerCase()] || 'bg-gray-500 text-white'}`} data-id="element-779">
      {marketplace}
    </span>;
};
export function LiveMarketTicker() {
  const {
    formatCurrency
  } = useLanguage();
  const renderTickerItems = items => <div className="flex gap-4" data-id="element-780">
      {items.map(item => <div key={item.id} className="flex-none w-[300px] bg-gray-50 dark:bg-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-700 hover:border-blue-500 dark:hover:border-brand-green transition-colors" data-id="element-781">
          <div className="flex items-center justify-between mb-3" data-id="element-782">
            <MarketplaceTag marketplace={item.marketplace} data-id="element-783" />
            <span className="text-xs text-gray-500 dark:text-gray-400 bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded" data-id="element-784">
              {item.grade}
            </span>
          </div>
          <div className="text-lg font-medium text-gray-900 dark:text-white mb-3" data-id="element-785">
            {item.device}
          </div>
          <div className="flex items-center justify-between" data-id="element-786">
            <div data-id="element-787">
              <div className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-788">
                {formatCurrency(item.price)}
              </div>
              <div className="text-sm text-gray-500 dark:text-gray-400" data-id="element-789">
                {item.volume}
              </div>
            </div>
            <div className={`flex items-center text-sm font-medium ${item.isPositive ? 'text-green-500' : 'text-red-500'}`} data-id="element-790">
              {item.isPositive ? <TrendingUpIcon className="h-4 w-4 mr-1" data-id="element-791" /> : <TrendingDownIcon className="h-4 w-4 mr-1" data-id="element-792" />}
              {item.change}
            </div>
          </div>
        </div>)}
    </div>;
  return <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-lg shadow-sm" data-id="element-793">
      <div className="p-4 border-b border-gray-200 dark:border-gray-800" data-id="element-794">
        <div className="flex items-center justify-between" data-id="element-795">
          <div className="flex items-center gap-2" data-id="element-796">
            <ActivityIcon className="h-5 w-5 text-blue-500 dark:text-brand-green" data-id="element-797" />
            <h2 className="text-lg font-medium text-gray-900 dark:text-white" data-id="element-798">
              Live Market Ticker
            </h2>
          </div>
          <button className="text-sm text-blue-600 dark:text-brand-green hover:opacity-80 transition-colors flex items-center" data-id="element-799">
            View All
            <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-800" />
          </button>
        </div>
      </div>
      <div className="p-4 overflow-hidden relative" data-id="element-801">
        <div className="animate-ticker flex" style={{
        animation: 'ticker 20s linear infinite'
      }} data-id="element-802">
          {renderTickerItems(initialMarketItems)}
          {renderTickerItems(initialMarketItems)}
        </div>
      </div>
    </div>;
}